import React, { useContext, useEffect, useMemo, useState, useRef } from "react";
import { TailSpin } from 'react-loader-spinner';

import Overview from "./Reports/report-pdf/Overview";
import FourQuadrants from "./Reports/report-pdf/FourQuadrants";
import HeartStarterQuadrants from "./Reports/report-pdf/HeartStarterQuadrants";
import AlignmentFlowFirst from "./Reports/report-pdf/AlignmentFlowFirst";
import AlignmentFlowSecond from "./Reports/report-pdf/AlignmentFlowSecond";
import Mindset from "./Reports/report-pdf/Mindset";
import ReflectAndIntegrate1 from "./Reports/report-pdf/ReflectAndIntegrate1";
import ReflectAndIntegrate2 from "./Reports/report-pdf/ReflectAndIntegrate2";
import ReflectAndIntegrate3 from "./Reports/report-pdf/ReflectAndIntegrate3";
import ReflectAndIntegrate4 from "./Reports/report-pdf/ReflectAndIntegrate4";
import Snapshot360 from "./Reports/report360-pdf/Snapshot360";
import StarterQuardrantPreview360 from "./Reports/report360-pdf/StarterQuardrantPreview360";
import YourQuardrantsFlowPreview360 from "./Reports/report360-pdf/YourQuardrantsFlowPreview360";
import HeartToSoulPreview360 from "./Reports/report360-pdf/HeartToSoulPreview360";
import QF_ItemOnePage360 from "./Reports/report360-pdf/QF_ItemOnePage360";
import QF_ItemTwoPage360 from "./Reports/report360-pdf/QF_ItemTwoPage360";
import QF_ItemThirdPage360 from "./Reports/report360-pdf/QF_ItemThirdPage360";
import HeartPreview360 from "./Reports/report360-pdf/HeartPreview360";
import SoulPreview360 from "./Reports/report360-pdf/SoulPreview360";
import MindPreview360 from "./Reports/report360-pdf/MindPreview360";
import StrengthPreview360 from "./Reports/report360-pdf/StrengthPreview360";
import LeadershipStyleFirst360 from "./Reports/report360-pdf/LeadershipStyleFirst360";
import LeadershipStyleSecond360 from "./Reports/report360-pdf/LeadershipStyleSecond360";
import LeadershipStyleThird360 from "./Reports/report360-pdf/LeadershipStyleThird360";
import LeadershipFlowPreview360 from "./Reports/report360-pdf/LeadershipFlowPreview360";
import LeadershipFlowSecondPreview360 from "./Reports/report360-pdf/LeadershipFlowSecondPreview360";
import LeadershipItemFirst360 from "../Report360/LeadershipItemFirst360";
import LeadershipItemSecond360 from "./Reports/report360-pdf/LeadershipItemSecond360";
import LeadershipItemThird360 from "./Reports/report360-pdf/LeadershipItemThird360";
import CollabrativeInFocus360 from "./Reports/report360-pdf/CollabrativeInFocus360";
import VisionaryInFocus360 from "./Reports/report360-pdf/VisionaryInFocus360";
import StrategicInFocus360 from "./Reports/report360-pdf/StrategicInFocus360";
import PerformanceInFocus360 from "./Reports/report360-pdf/PerformanceInFocus360";
import SnapshotFirstGroup from "./Reports/groupReport-pdf/SnapshotFirstGroup";
import SnapshotSecondGroup from "./Reports/groupReport-pdf/SnapshotSecondGroup";
import SnapshotThirdGroup from "./Reports/groupReport-pdf/SnapshotThirdGroup";
import StarterQuardrant from "./Reports/report-pdf/StarterQuardrant";
import StarterQuardrantGroup from "./Reports/groupReport-pdf/StarterQuardrantGroup";
import HeartStarterQuadrantGroup from "./Reports/groupReport-pdf/HeartStarterQuadrantGroup";
import SoulStarterQuadrantGroup from "./Reports/groupReport-pdf/SoulStarterQuadrantGroup";
import YourQuardrantsFlowGroup from "./Reports/groupReport-pdf/YourQuardrantsFlowGroup";
import YourQuardrantsFlowSecondGroup from "./Reports/groupReport-pdf/YourQuardrantsFlowSecondGroup";
import HeartToSoulFirstGroup from "./Reports/groupReport-pdf/HeartToSoulFirstGroup";
import SoulToHeartGroup from "./Reports/groupReport-pdf/SoulToHeartGroup";
import QF_ItemOnePageGroup from "./Reports/groupReport-pdf/QF_ItemOnePageGroup";
import QF_ItemTwoPageGroup from "./Reports/groupReport-pdf/QF_ItemTwoPageGroup";
import Heart from "./Reports/report-pdf/Heart";
import Soul from "./Reports/report-pdf/Soul";
import Mind from "./Reports/report-pdf/Mind";
import Strength from "./Reports/report-pdf/Strength";
import LeadershipStyle2 from "./Reports/report-pdf/LeadershipStyle2";
import LeadershipStyle from "./Reports/report-pdf/LeadershipStyle";
import LeadershipStyleCollabrativeGroup from "./Reports/groupReport-pdf/LeadershipStyleCollabrativeGroup";
import LeadershipFlowGroup from "./Reports/groupReport-pdf/LeadershipFlowGroup";
import LeadershipFlowSecondGroup from "./Reports/groupReport-pdf/LeadershipFlowSecondGroup";
import LeadershipFlowThirdGroup from "./Reports/groupReport-pdf/LeadershipFlowThirdGroup";
import LeadershipFlowFourGroup from "./Reports/groupReport-pdf/LeadershipFlowFourGroup";
import LeadershipFlowFifthGroup from "./Reports/groupReport-pdf/LeadershipFlowFifthGroup";
import Item from "./Reports/report-pdf/Item";
import ItemTwo from "./Reports/report-pdf/ItemTwo";
import LeadershipItemGroup from "./Reports/groupReport-pdf/LeadershipItemGroup";
import LeadershipItemSecondGroup from "./Reports/groupReport-pdf/LeadershipItemSecondGroup";
import LeadershipItemThirdGroup from "./Reports/groupReport-pdf/LeadershipItemThirdGroup";
import CollabrativeInFocus from "./Reports/report-pdf/CollabrativeInFocus";
import VisionaryInFocus from "./Reports/report-pdf/VisionaryInFocus";
import StrategicInFocus from "./Reports/report-pdf/StrategicInFocus";
import PerformanceInFocus from "./Reports/report-pdf/PerformanceInFocus";
import CoverPage from "./Reports/report-pdf/CoverPage";
import TableContentPreview from "./Reports/report-pdf/TableContentPreview";
import HomeStarterQuadrantPreview from "./Reports/report-pdf/HomeStarterQuadrantPreview";
import GroupStarterQuadrantChartPreview from "./Reports/groupReport-pdf/GroupStarterQuadrantChartPreview";
import HomeQuadrantFlow from "./Reports/report-pdf/HomeQuadrantFlow";
import HomeLeadershipStyle from "./Reports/report-pdf/HomeLeadershipStyle";
import HomeMindset from "./Reports/report-pdf/HomeMindset";
import MindsetResult from "./Reports/report-pdf/MindsetResult";
import HomeReflectAndIntegrate from "./Reports/report-pdf/HomeReflectAndIntegrate";
import GroupHeartPreview from "./Reports/groupReport-pdf/GroupHeartPreview.jsx";
import GroupSoulPreview from "./Reports/groupReport-pdf/GroupSoulPreview.jsx";
import GroupMindPreview from "./Reports/groupReport-pdf/GroupMindPreview.jsx";
import GroupStrengthPreview from "./Reports/groupReport-pdf/GroupStrengthPreview.jsx";
import CollabrativeGroupPreview from "./Reports/groupReport-pdf/CollabrativeGroupPreview.jsx";
import VisionaryGroupPreview from "./Reports/groupReport-pdf/VisionaryGroupPreview.jsx";
import StrategicGroupPreview from "./Reports/groupReport-pdf/StrategicGroupPreview.jsx";
import PerformanceGroupPreview from "./Reports/groupReport-pdf/PerformanceGroupPreview.jsx";
import GroupMindsetResult from "./Reports/groupReport-pdf/GroupMindsetResult.jsx";
import GroupAlignmentFlowFirst from "./Reports/groupReport-pdf/GroupAlignmentFlowFirst.jsx";
import GroupAlignmentFlowSecond from "./Reports/groupReport-pdf/GroupAlignmentFlowSecond.jsx";
import MindsetSecondGroup from "./Reports/groupReport-pdf/MindsetSecondGroup.jsx";
import MindsetGroup from "./Reports/groupReport-pdf/MindsetGroup.jsx";
import GroupReportContext from "../../Context/GroupReportContext.js";
import QF_ItemThreePageGroup from "./Reports/groupReport-pdf/QF_ItemThreePageGroup.jsx";

const formatShortDate = (dateStr) => {
  if (!dateStr) return "";
  return new Date(dateStr).toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });
};

// Page mapping for Group Report (28 pages total)
const pageMapping = {
  "Cover Page": 1,
  "Table of Contents": 2,
  "Summary Snapshot": 3,

  "Starter Quadrant Results": 4,
  "Starter Quadrant Chart": 5,

  "Quadrant Flow Results": 6,
  "Introduction": 7,

  "Items Overview Group": 8,
  "QFItemOnePageGroup": 8,
  "QFItemTwoPageGroup": 9,
  "QFItemThreePageGroup": 10,

  "Quadrant In Focus Group": 11,
  "Heart": 11,
  "Soul": 12,
  "Mind": 13,
  "Strength": 14,

  "Leadership Style Results": 15,
  "Leadership Style Chart": 16,

  "Collaborative to Strategic": 17,
  "Leadership Flow Introduction Group": 18,
  "Flow Introduction Group": 18,

  "Items Overview Leadership Group": 19,
  "ItemGroup 1": 19,
  "ItemGroup 2": 20,
  "ItemGroup 3": 21,

  "Leadership Style In Focus": 22,
  "Collaborative": 22,
  "Visionary": 23,
  "Strategic": 24,
  "Performance": 25,

  "AlignmentGroup 1": 26,
  "Mindset Results": 27,
  "Final Thoughts": 28,
};

const reportSections = [
  "Cover Page",
  "Table of Contents",
  "Summary Snapshot",
  "Starter Quadrant Results",
  "Starter Quadrant Chart",
  "Quadrant Flow Results",
  "Introduction",
  "Items Overview Group",
  "QFItemTwoPageGroup",
  "QFItemThreePageGroup",
  "Heart",
  "Soul",
  "Mind",
  "Strength",
  "Leadership Style Results",
  "Leadership Style Chart",
  "Collaborative to Strategic",
  "Flow Introduction Group",
  "Items Overview Leadership Group",
  "ItemGroup 2",
  "ItemGroup 3",
  "Collaborative",
  "Visionary",
  "Strategic",
  "Performance",
  "AlignmentGroup 1",
  "Mindset Results",
  "Final Thoughts",
];

export default function GroupReportPreview({ activeSubMenu, activeMenu, apiData, groupData, menuItems }) {
  const [filteredPreviewData, setFilteredPreviewData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const sectionRefs = useRef({});
  const [createdgroup360Date, setCreatedgroup360Date] = useState("");

  const groupReportCtx = useContext(GroupReportContext)

  // Define the report type for Group reports
  const reportType = "GROUP REPORT";

  // Add smooth scrolling effect
  useEffect(() => {
    const currentSection = activeSubMenu || activeMenu;
    const el = sectionRefs.current[currentSection];
    if (el && el.scrollIntoView) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [activeMenu, activeSubMenu]);

  useEffect(() => {
    const rawDate = groupReportCtx?.selectedReport?.createdDate ?? groupReportCtx?.currentTeamData?.createdDate;

    const reportDate = rawDate
      ? new Date(rawDate).toLocaleDateString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric",
      })
      : undefined;

    setCreatedgroup360Date(reportDate);
  }, [groupReportCtx, reportType]);

  const headerData = useMemo(() => {

    const teamName =
      groupReportCtx?.selectedReport?.teamName ||
      groupReportCtx?.selectedReport?.teamname ||
      "";

    console.log(groupReportCtx, "groupReportCtx")
    const clientData = localStorage.getItem("clientData");
    const parsedData = clientData && JSON.parse(clientData);
    const resolvedCompany =
      parsedData?.company;
    const baseDate =
      groupData?.createdDate ||
      groupReportCtx?.selectedReport?.createdDate ||
      apiData?.lastAsmtCompletedAt || parsedData?.lastAsmtCompletedAt ||
      "";

    const resolvedDate = baseDate ? formatShortDate(baseDate) : "";
    const resolvedCompletionDate = createdgroup360Date || resolvedDate;

    return {
      respondentName: teamName,
      companyName: resolvedCompany,
      date: resolvedDate,
      reportDataName: teamName,
      completionDate: resolvedCompletionDate,
    };
  }, [
    apiData?.clientData?.organizationName,
    apiData?.lastAsmtCompletedAt,
    createdgroup360Date,
    groupData?.clientData?.organizationName,
    groupData?.createdDate,
    groupData?.teamName,
    groupData?.teamname,
    groupReportCtx?.selectedReport?.createdDate,
    groupReportCtx?.selectedReport?.teamName,
    groupReportCtx?.selectedReport?.teamname,
  ]);

  useEffect(() => {
    const hasValue = Object.values(headerData).some(Boolean);
    if (hasValue) {
      sessionStorage.setItem("selfReportHeaderData", JSON.stringify(headerData));
    }
  }, [headerData]);

  useEffect(() => {
    // Filter preview data based on current team name
    // Always try to load data, even if groupData is null
    try {
      const previewData = localStorage.getItem("groupReportPreviewData");

      if (previewData && previewData !== 'undefined' && previewData !== 'null') {
        const parsedPreviewData = JSON.parse(previewData);

        // Handle different possible response structures
        let dataArray = [];

        // Check if data is directly an array
        if (Array.isArray(parsedPreviewData)) {
          dataArray = parsedPreviewData;
        }
        // Check if data is nested under 'data' property
        else if (parsedPreviewData?.data && Array.isArray(parsedPreviewData.data)) {
          dataArray = parsedPreviewData.data;
        }
        // Check if parsedPreviewData itself contains the team data
        else if (parsedPreviewData && typeof parsedPreviewData === 'object') {
          // If it's a single object, convert to array
          dataArray = [parsedPreviewData];
        }

        if (dataArray.length > 0) {
          // Get available team names for filtering
          const availableTeamNames = dataArray.map(teamData => {
            if (!teamData) return null;
            return teamData.teamname || teamData.teamName || teamData.name || teamData.groupName;
          }).filter(name => name);

          // Filter data for current team only - try multiple property names
          const teamFilteredData = dataArray.filter(teamData => {
            if (!teamData) return false;

            // If no specific team name provided, include all data
            if (!groupData?.teamName) {
              return true;
            }

            // Try different property names for team name
            const teamName = teamData.teamname || teamData.teamName || teamData.name || teamData.groupName;
            return teamName === groupData.teamName;
          });

          // If no matching team found, use the first available team data as fallback
          if (teamFilteredData.length === 0 && dataArray.length > 0) {
            setFilteredPreviewData([dataArray[0]]);
            setIsLoading(false);
          } else if (teamFilteredData.length > 0) {
            setFilteredPreviewData(teamFilteredData);
            setIsLoading(false);
          } else {
            // If no team data found at all, use first available team
            if (dataArray.length > 0) {
              setFilteredPreviewData([dataArray[0]]);
              setIsLoading(false);
            } else {
              setFilteredPreviewData(null);
              setIsLoading(true);
            }
          }
        } else {
          // If no array found, use the full parsed data
          if (parsedPreviewData && Object.keys(parsedPreviewData).length > 0) {
            setFilteredPreviewData([parsedPreviewData]);
            setIsLoading(false);
          } else {
            setFilteredPreviewData(null);
            setIsLoading(true);
          }
        }
      } else {
        setFilteredPreviewData(null);
        setIsLoading(true);
      }
    } catch (error) {
      setFilteredPreviewData(null);
      setIsLoading(true);
    }
  }, [apiData, groupData, activeMenu, activeSubMenu]);

  const renderCommonContent = (sectionName, previewData, pageNumber) => {
    // Ensure preview data is safe to pass
    const safePreviewData = previewData || filteredPreviewData || null;

    // If no safePreviewData but localStorage has data, use first available team
    if (!safePreviewData) {
      try {
        const previewDataFromStorage = localStorage.getItem("groupReportPreviewData");
        if (previewDataFromStorage && previewDataFromStorage !== 'undefined' && previewDataFromStorage !== 'null') {
          const parsedPreviewData = JSON.parse(previewDataFromStorage);
          if (parsedPreviewData?.data && Array.isArray(parsedPreviewData.data) && parsedPreviewData.data.length > 0) {
            const fallbackData = [parsedPreviewData.data[0]];
            return renderWithPreviewData(sectionName, fallbackData, pageNumber);
          }
        }
      } catch (error) {
        // Silently handle error, continue with null data
      }
    }

    return renderWithPreviewData(sectionName, safePreviewData, pageNumber);
  };


  const renderWithPreviewData = (sectionName, previewData, pageNumber) => {

    // groupReportCtx?.setPreviewData(previewData)
    // groupReportCtx?.setApiData(apiData)

    // console.log("sectionName", sectionName)
    switch (sectionName) {
      case "Cover Page":
        // Extract team name from groupData or apiData
        const teamName = groupData?.teamname || groupData?.teamName || apiData?.teamname || apiData?.teamName || '';
        return <CoverPage name={teamName || apiData?.fullName} apiData={groupData || apiData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} teamName={teamName} groupData={groupData} />;
      case "Table of Contents":
        // Define the TOC sections and their keys as used in the report
        const tocSections = [
          { label: "SNAPSHOT", key: "Summary Snapshot" },
          { label: "STARTER QUADRANT", key: "Starter Quadrant Results" },
          { label: "QUADRANT FLOW", key: "Quadrant Flow Results" },
          { label: "LEADERSHIP STYLE", key: "Leadership Style Results" },
          { label: "LEADERSHIP FLOW", key: "Collaborative to Strategic" },
          { label: "GAP ANALYSIS", key: "AlignmentGroup 1" },
          { label: "MINDSET", key: "Mindset Results" },
          { label: "FINAL THOUGHTS", key: "Final Thoughts" },
        ];
        // Helper to get page number for a section
        // const pageMapping = {
        //   "Cover Page": 1,
        //   "Table of Contents": 2,
        //   "Overview": 3,
        //   "Summary Snapshot": 4,
        //   "Starter Quadrant": 5,
        //   "Four Quadrants": 6,
        //   "Starter Quadrant Chart": 7,
        //   "Starter Quadrant Results": 8,
        //   "HomeQuadrantFlow": 9,
        //   "Home Leadership Style": 18,
        //   "Home Mindset": 32,
        //   "Home Reflect And Integrate": 36,
        // };
        const getPageNumber = (sectionKey) => pageMapping[sectionKey] || 1;
        const tocPageNumbers = tocSections.map(section => getPageNumber(section.key));
        return <TableContentPreview
          apiData={groupData || apiData}
          menuItems={menuItems}
          previewData={previewData}
          reportType={reportType}
          pageNumber={pageNumber}
          tocSections={tocSections}
          tocPageNumbers={tocPageNumbers}
        />;
      // case "Overview":
      //   return <Overview apiData={groupData || apiData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;
      case "Summary Snapshot":
        return (
          <SnapshotSecondGroup apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />
        )
      // case "Starter Quadrant":
      //   return <HomeStarterQuadrantPreview apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;
      // case "Four Quadrants":
      //   return <FourQuadrants apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;

      case "Starter Quadrant Results":
        return <HeartStarterQuadrantGroup apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />
      case "Starter Quadrant Chart":
        return <GroupStarterQuadrantChartPreview apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />

      //Quadrant Flow 
      // case "HomeQuadrantFlow":
      //   return <HomeQuadrantFlow apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;
      case "Introduction":
        return <YourQuardrantsFlowGroup groupData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;
      case "Quadrant Flow Results":
        return <HeartToSoulFirstGroup apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />
      case "Items Overview Group":
      case "QFItemOnePageGroup":
        return <QF_ItemOnePageGroup apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;
      case "QFItemTwoPageGroup":
        return <QF_ItemTwoPageGroup apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;
      case "QFItemThreePageGroup":
        return <QF_ItemThreePageGroup apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;

      case "Quadrant In Focus Group":
      case "Heart":
        return <GroupHeartPreview apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;
      case "Soul":
        return <GroupSoulPreview apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;
      case "Mind":
        return <GroupMindPreview apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;
      case "Strength":
        return <GroupStrengthPreview apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;
      //Leadership Style  
      // case "Home Leadership Style":
      //   return <HomeLeadershipStyle apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;
      // case "Leadership Style Introduction":
      //   return <LeadershipStyle apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />

      case "Leadership Style Results":
        return <LeadershipStyleCollabrativeGroup apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />

      case "Leadership Style Chart":
        return <LeadershipStyle2 apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;
      //Leadership Flow    

      case "Collaborative to Strategic":
        return <LeadershipFlowSecondGroup apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;

      case "Leadership Flow Introduction Group":
      case "Flow Introduction Group":
        return <LeadershipFlowGroup apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;

      case "Items Overview Leadership Group":
      case "ItemGroup 1":
        return <LeadershipItemGroup apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;
      case "ItemGroup 2":
        return <LeadershipItemSecondGroup apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;
      case "ItemGroup 3":
        return <LeadershipItemThirdGroup apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;
      case "Collaborative":
        return <CollabrativeGroupPreview apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;
      case "Visionary":
        return <VisionaryGroupPreview apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;
      case "Strategic":
        return <StrategicGroupPreview apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;
      case "Performance":
        return <PerformanceGroupPreview apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;
      //Alignment Flow

      case "AlignmentGroup 1":
        return <GroupAlignmentFlowFirst apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;
      case "AlignmentGroup 2":
        return <GroupAlignmentFlowSecond apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;
      //Mindset

        case "Mindset Results":
        return <GroupMindsetResult apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;
      //Reflect and Integrate  

      // case "Home Mindset":
      //   return <HomeMindset apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;
      // case "Mindset Introduction Group":
      // case "MindsetGroup 1":
      //   return <MindsetGroup apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;
      // case "MindsetGroup 2":
      //   return <MindsetSecondGroup apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;
     
      // case "Home Reflect And Integrate":
      //   return <HomeReflectAndIntegrate apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;
      // case "Reflect and Integrate":
      //   return <ReflectAndIntegrate1 apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;
      // case "Life Integration":
      //   return <ReflectAndIntegrate2 apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;
      // case "Leadership Integration":
      //   return <ReflectAndIntegrate3 apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;
      case "Final Thoughts":
        return <ReflectAndIntegrate4 apiData={groupData} previewData={previewData} reportType={reportType} pageNumber={pageNumber} />;
      // 360-specific section
      case "Feedback Comparison":
        return <div>Feedback Comparison Content for Group Report - Preview Data: {previewData ? 'Available' : 'Not Available'}</div>;
      // Group-specific section
      case "Group Dynamics":
        return <div>Group Dynamics Content for Group Report - Preview Data: {previewData ? 'Available' : 'Not Available'}</div>;
      // default:
      //   return (
      //     <div>
      //       <p>Select a section to view the report</p>
      //     </div>
      //   );
    }
  };

  // Build a map: page number -> all section names for that page
  const pageToSectionsMap = {};
  Object.entries(pageMapping).forEach(([section, page]) => {
    if (!pageToSectionsMap[page]) pageToSectionsMap[page] = [];
    pageToSectionsMap[page].push(section);
  });

  const sectionToPageMap = pageMapping; // alias for clarity

  const renderAllSections = () => {
    const currentSection = activeSubMenu || activeMenu;
    const currentPageNumber = pageMapping[currentSection];
    const renderedPages = new Set();

    return reportSections.map((sectionName, index) => {
      // const pageNumber = pageMapping[sectionName] || index + 1;
      const pageNumber = pageMapping[sectionName]

      // Skip if this page number has already been rendered
      if (renderedPages.has(pageNumber) || !pageNumber) {
        return null;
      }
      renderedPages.add(pageNumber);

      const className = sectionName?.toLowerCase().replace(/\s+/g, '-');
      return (
        <div
          key={sectionName}
          className={className}
          ref={el => {
            // Set ref for all section names that map to this page
            if (pageToSectionsMap[pageNumber]) {
              pageToSectionsMap[pageNumber].forEach(sec => {
                sectionRefs.current[sec] = el;
              });
            } else {
              sectionRefs.current[sectionName] = el;
            }
          }}
          style={{ marginBottom: "40px", background: "#fff", width: "612px", height: "792px", position: 'relative', padding: "36px 72px", boxSizing: "border-box" }}
        >
          {renderCommonContent(sectionName, filteredPreviewData, pageNumber)}
        </div>
      );
    }).filter(Boolean); // Remove null entries
  };

  return (
    <div>
      {isLoading && (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          marginBottom: "40px"
        }}>
          <TailSpin
            height="60"
            width="60"
            color="#007bff"
            ariaLabel="loading"
            radius="1"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          />
        </div>
      )}
      {!isLoading && renderAllSections()}
    </div>
  );
}
